import { fromJS } from 'immutable';
import LocalStorageUtility from '../common/localStorageUtility/localStorageUtility';
import * as types from '../constants';

const initialState = fromJS({
  leafEvents: {},
  nextMatch: [],
  leafCompetition: {},
  leafCompetitionMini: {},
  isLoaded: false,
  nextMatches: {},
});

function checkCompetitionsRows(stateName) {
  if (stateName) {
    const newMap = stateName.toJS();
    const preferredMap = LocalStorageUtility.getPreferredMatch();
    Object.keys(newMap).forEach((key) => {
      if (newMap[key] && newMap[key].length) {
        newMap[key].forEach((competition) => {
          competition.competitionMatches = competition.competitionMatches.map((match) => {
            if (preferredMap[match.matchId] || preferredMap[match.id]) {
              match.favourite = true;
            } else {
              match.favourite = false;
            }
            return match;
          });
        });
      } else {
        newMap[key].competitionMatches = newMap[key].competitionMatches.map((match) => {
          if (preferredMap[match.matchId] || preferredMap[match.id]) {
            match.favourite = true;
          } else {
            match.favourite = false;
          }
          return match;
        });
      }
    });
    /*newMap.competitionMatches = newMap.competitionMatches.map((match) => {
      if (preferredMap[match.matchId] || preferredMap[match.id]) {
        match.favourite = true;
      } else {
        match.favourite = false;
      }
      return match;
    });*/
    if (newMap && newMap[0] && newMap[0].competitionMatches) {
      Object.assign(newMap[0], {
        competitionMatches: Object.assign([], newMap[0].competitionMatches.filter(match => !match.hideMatch)),
      });
    }
    return fromJS(newMap);
  }
  return fromJS({});
}

function checkFavMatch(state) {
  if (state) {
    const newMap = state.toJS();
    const preferredMap = LocalStorageUtility.getPreferredMatch();
    if (preferredMap[newMap.matchId] || preferredMap[newMap.id]) {
      newMap.favourite = true;
    } else {
      newMap.favourite = false;
    }
    return fromJS(newMap);
  }
  return fromJS({});
}

export default function sportsReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_LEAF_EVENT_SUCCESS:
      return state.mergeIn(['leafEvents'], { [action.widgetId]: (checkFavMatch(fromJS(action.data))) });
      //return state.set('leafEvent', (checkFavMatch(fromJS(action.data))));
    case types.GET_LEAF_COMPETITION_SUCCESS:
      if (!action.noFavStar) {
        return state.mergeIn(['leafCompetition'], { [action.widgetId]: (checkCompetitionsRows(fromJS(action.data))) })
          .set('isLoaded', true);
      } else {
        return state.mergeIn(['leafCompetitionMini'], { [action.widgetId]: (checkCompetitionsRows(fromJS(action.data))) })
          .set('isLoaded', true);
      }
    case types.GET_LEAF_SPORT_SUCCESS:
      return state.mergeIn(['leafCompetition'], { [action.widgetId]: checkCompetitionsRows(fromJS(action.data)) });
    case types.GET_NEXT_MATCH_SUCCESS:
      return state.mergeIn(['nextMatches'], { [action.widgetId]: (checkFavMatch(fromJS(action.data))) });
    case types.SET_IS_FAVOURITE:
      return state.setIn(['leafCompetition', action.widgetId], fromJS(checkCompetitionsRows(state.getIn(['leafCompetition', action.widgetId]))))
        .setIn(['leafEvents', action.widgetId], fromJS(checkFavMatch(state.getIn(['leafEvents', action.widgetId]))));
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sports.js